import { Icon, IconsEnum } from 'components/Icons';
import { Leaf, ScommesseLeafItem } from '../cells';
import { useEsito, useInfoEsito } from 'features/sport/hooks';

import { DynamicImage } from 'components/Image';
import React from 'react';
import { ScommesseQuoteListItemProps } from '.';
import classNames from 'classnames';
import { isNotEmpty } from 'utility/functions';
import styles from './ScommesseQuoteList.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export const EsitoListItem = ({
  itemKey,
  disabled,
  isSelected,
  scommessaKey,
  infoAggiuntivaKey,
  onClick,
}: ScommesseQuoteListItemProps) => {
  const { t } = useTranslation();

  const esito = useEsito(itemKey);
  const { infoEsitoKey } = esito ?? {};
  const infoEsito = useInfoEsito(infoEsitoKey ?? '');
  const { iconSrc, descrizione, descrizioneTrKey } = infoEsito ?? {};

  return (
    <button
      type="button"
      disabled={disabled}
      data-testid={`Esito-ListItem-${itemKey}`}
      className={classNames(styles.btn, { [styles.active]: isSelected })}
      onClick={() => onClick(itemKey)}
    >
      <span className={styles.check}>
        {isSelected && <Icon iconId={IconsEnum.CHECK} className={styles.checkIcon} color="var(--color-primary)" />}
      </span>
      <ul className={styles.list}>
        <li className={styles.singleItem}>
          <span>{t(descrizioneTrKey, descrizione)}</span>
        </li>
        <li className={classNames(styles.singleItem, styles.left)}>
          {isNotEmpty(iconSrc) && (
            <span className={styles.imageContainer}>
              <DynamicImage className={styles.image} src={`${iconSrc}`} alt={''} fill loading="lazy" decoding="async" />
            </span>
          )}
          <span>
            <Leaf
              itemKey={itemKey}
              scommessaKey={scommessaKey}
              infoAggiuntivaKey={infoAggiuntivaKey}
              type={ScommesseLeafItem.Esito}
            />
          </span>
        </li>
      </ul>
    </button>
  );
};
